export class Step3 {
    constructor() {}
    intitule = 'stepper.form.mapa_re.step3';
    getobjet = 'form.mapa_re.getobjet';
    getspan2 = 'form.mapa_re.getspan2';
    getspan3 = 'form.mapa_re.getspan3';
    getclassprincipale = 'form.mapa_re.getclassprincipale';
    getclasssupplementaire = 'form.mapa_re.getclasssupplementaire';
    getspan4 = 'form.mapa_re.getspan4';
    getspan5 = 'form.mapa_re.getspan5';
    getnum = 'form.mapa_re.getnum';
    gettypevoie = 'form.mapa_re.gettypevoie';
    getnomvoie = 'form.mapa_re.getnomvoie';
    getcp = 'form.mapa_re.getcp';
    getville = 'form.mapa_re.getville';
    getlieuexecutionlivraison = 'form.mapa_re.getlieuexecutionlivraison';
    getmotclef = 'form.mapa_re.getmotclef';
    ajouter = 'boutons.ajouter';
    supprimer = 'boutons.supprimer';

}
